module.exports = ".login-error {\r\n    margin-left: -10px !important;\r\n}\r\n\r\n.login-password{\r\n    position: absolute;\r\n    display: inline;\r\n    top: 10px;\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/section/login/login.component.css
// module id = ./src/app/section/login/login.component.css
// module chunks = main